export default {
  club_name: 'Ettan Fotboll',
  club_name_short: 'EF',
  stadium_name: '',
  staging_url: 'https://ettan.api.fangroup.io',
  prod_url: 'https://ettan.api.fangroup.io',
  api: '/api',
  facebook: 'Ettanfotboll',
  basename: '/ettan',
  club_logo: '/assets/teams/ettan.png',
  app_name: 'ettan',
  websale_name: 'ettan',
  ntb_team_id: 10028,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'ettan',
  monolithEnabled: false,
};
